import CheckoutPromoCodeForm from './CheckoutPromoCodeForm';

export default CheckoutPromoCodeForm;
